import { asyncSelectWidgetObjectName } from '../../inputs/async-select/hooks/asyncSelectObjectName.ts';
import { type IButtonWidget } from './IButtonWidget.ts';

export function getActionDataObjectName(widget: IButtonWidget, index: number) {
  return `${asyncSelectWidgetObjectName(widget.code)}-${index}`;
}
